import React, { useEffect, useState, useMemo } from 'react';
import {
    Button,
    Switch,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Box,
    Grid, 
    Typography,
    CircularProgress, 
    Paper,IconButton,
    Tooltip,Avatar,
    TextField,
    InputAdornment} from '@mui/material';
    
import { DataGrid } from '@mui/x-data-grid';
import SearchIcon from '@mui/icons-material/Search';
import { Delete as DeleteIcon } from '@mui/icons-material';
import AddRol from 'src/components/AddRol';
import WidgetAlert from 'src/widgets/WidgetAlert';
import services from 'src/services/Services';
import singletonMysqlApis from 'src/services/IntanceMysqlApis';

const labelModules = {
    modRoles: 'roles',
    modUsers: 'usuarios',
    modTokens: 'tokens',
    modExist: 'existencias',
    modPedidos: 'pedidos',
    modPedidosInt: 'pedidosInternos',
    modPrecio: 'precio',
    modExport: 'exportacion',
};

const AdminRoles = () => {
    const [dataRoles, setDataRoles] = useState([]);
    const [loading, setLoading] = useState(true);

    const [alert, setAlert] = useState({ open: false, type: 'success', message: '' });

    const [openModal, setOpenModal] = useState(false);
    const [selectedRol, setSelectedRol] = useState({ id: '', name: '' });
    const [searchText, setSearchText] = useState('');
    
        const filteredRows=useMemo(() => {
    return dataRoles.filter((row) =>
    Object.values(row).some((value) =>
    String(value).toLowerCase().includes(searchText.toLowerCase())
        )
      );
    }, [dataRoles, searchText]);

    useEffect(() => {
        const token = localStorage.getItem("session");
        if (token) singletonMysqlApis.setToken(token);
        getRoles();
    }, []);

    const getRoles = async () => {
        try {
            const response = await services.getModulesByRolMysql();
            const infoRoles = response.data;

            const dataRolesMap = infoRoles.reduce((roles, line) => {
                roles[line.NAME] = roles[line.NAME] || [];
                roles[line.NAME].push(line);
                return roles;
            }, {});

            const dataFinTemp = Object.values(dataRolesMap).map((rolesArray) => {
                const base = {
                    id: rolesArray[0].ID,
                    name: rolesArray[0].NAME,
                    description: rolesArray[0].DESCRIPTION,
                    fechaCreacion: rolesArray[0].Module,
                    modRoles: false,
                    modUsers: false,
                    modTokens: false,
                    modExist: false,
                    modPedidos: false,
                    modPedidosInt: false,
                    modExport: false,
                    modPrecio: false,
                };
                rolesArray.forEach((obj) => {
                    const val = obj.Module === 'true';
                    if (obj.Module === 'roles') base.modRoles = true;
                    if (obj.Module === 'existencias') base.modExist = true;
                    if (obj.Module === 'pedidos') base.modPedidos = true;
                    if (obj.Module === 'pedidosInternos') base.modPedidosInt = true;
                    if (obj.Module === 'tokens') base.modTokens = true;
                    if (obj.Module === 'usuarios') base.modUsers = true;
                    if (obj.Attribute === 'exportacion') base.modExport = val;
                    if (obj.Attribute === 'precio') base.modPrecio = val;
                });
                return base;
            });

            setDataRoles(dataFinTemp);
            setLoading(false);
        } catch (error) {
            console.error(error);
        }
    };

    const handleChangeSwitch = (rowId, field, checked) => {
        setDataRoles((prev) =>
            prev.map((row) => {
                if (row.id === rowId) {
                    const updatedRow = { ...row, [field]: checked };

                    if (field === 'modExist' && !checked) updatedRow.modExport = false;
                    if (field === 'modExport' && checked) updatedRow.modExist = true;

                    updateRoles(updatedRow);
                    return updatedRow;
                }
                return row;
            })
        );
    };

    const updateRoles = async (row) => {
        const dataModules = Object.keys(labelModules).filter((key) => row[key]).map((key) => labelModules[key]);

        const body = {
            id: row.id,
            name: row.name,
            description: row.description,
            composite: false,
            clientRole: true,
            containerId: '2758d422-8dff-4b47-9706-40559e829d47',
            attributes: {
                fechaCreacion: [row.fechaCreacion],
                exportacion: [row.modExport],
                precio: [row.modPrecio],
                modulos: dataModules,
            },
        };

        try {
            await services.updateAttributeRole(row.id, body);
            setAlert({ open: true, type: 'success', message: '¡Se ha actualizado el rol!' });
        } catch (error) {
            console.error('Error actualizando rol:', error.message);
            setAlert({ open: true, type: 'error', message: 'Error al actualizar el rol' });
        }
    };

    const handleDeleteRole = async () => {
        try {
            await services.deleteRole(selectedRol.id);
            setOpenModal(false);
            setAlert({ open: true, type: 'success', message: '¡Se ha eliminado el rol!' });
            getRoles();
        } catch (error) {
            console.error(error);
            setAlert({ open: true, type: 'error', message: 'Error al eliminar el rol' });
        }
    };

    const columns = [
        { field: 'name', headerName: 'Nombre', flex: 1 },
        { field: 'description', headerName: 'Descripción', flex: 2 },
        { field: 'fechaCreacion', headerName: 'Fecha Creación', flex: 1 },
        ...Object.keys(labelModules).map((key) => ({
            field: key,
            headerName: labelModules[key],
            renderCell: (params) => (
                <Switch
                    checked={params.value}
                    onChange={(e) => handleChangeSwitch(params.row.id, key, e.target.checked)}
                />
            ),
            flex: 1,
        })),
        {
            field: 'acciones',
            headerName: 'Eliminar',
            renderCell: (params) =>
                params.row.name !== 'Administrador' ? (
                    <Tooltip title="Eliminar rol">
                        <IconButton
                            size="small"
                            onClick={() => setSelectedRol({ id: params.row.id, name: params.row.name }) & setOpenModal(true)}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                ) : null,
            flex: 0.5,
        },
    ];

    return (
        <Box sx={{ pl: 0, ml: 0, width: '100%' }}>
            <WidgetAlert open={alert.open} type={alert.type} message={alert.message} onClose={() => setAlert({ ...alert, open: false })} />

            <Paper elevation={0} sx={{ mb: 3, p: 2, borderRadius: 3, background: 'linear-gradient(180deg,#fff,#f7fbff)' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Avatar sx={{ bgcolor: 'transparent', width: 48, height: 48 }}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12Z" stroke="#1976d2" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/><path d="M20 20C20 16.6863 16.4183 14 12 14C7.58172 14 4 16.6863 4 20" stroke="#1976d2" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                        </Avatar>
                        <Box>
                            <Typography variant="h5" sx={{ fontWeight: 800 }}>Administración de Roles</Typography>
                        </Box>
                    </Box>
                    <AddRol getRoles={getRoles} handlerOpenAlertAdd={() => setAlert({ open: true, type: 'success', message: '¡Se agregó exitosamente el rol!' })} />
                </Box>
            </Paper>

            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
                    <CircularProgress />
                </Box>
            ) : (
                <Paper elevation={1} sx={{ borderRadius: 3, overflow: 'hidden', boxShadow: '0 12px 36px rgba(16,24,40,0.06)' }}>
                    <Box sx={{ width: '100%', '& .MuiDataGrid-root': { border: 'none' } }}>
                        <TextField

                    size="small"

                    placeholder="Buscar…"

                    value={searchText}

                    onChange={(e) => setSearchText(e.target.value)}

                    InputProps={{

                        startAdornment: (
<InputAdornment position="start">
<SearchIcon />
</InputAdornment>

                        ),

                    }}

                />
                        <DataGrid
                            rows={filteredRows}
                            columns={columns}
                            getRowId={(row) => row.name}
                            pageSize={10}
                            rowsPerPageOptions={[5, 10, 20]}
                            disableSelectionOnClick
                            autoHeight
                            sx={{
                                '& .MuiDataGrid-columnHeaders': { backgroundColor: '#f3f7fb', fontWeight: 800, borderBottom: '1px solid rgba(0,0,0,0.04)' },
                                '& .MuiDataGrid-cell': { alignItems: 'center' },
                                '& .MuiDataGrid-row:hover': { backgroundColor: '#fbfdff', transform: 'translateY(-2px)' },
                                '& .MuiDataGrid-footerContainer': { backgroundColor: '#fafcff', borderTop: '1px solid rgba(0,0,0,0.04)' },
                                '& .MuiDataGrid-virtualScroller': { background: 'linear-gradient(180deg,#fff,#fbfdff)' },
                                '& .MuiDataGrid-row': { transition: 'transform .12s ease' },
                            }}
                        />
                    </Box>
                </Paper>
            )}

            <Dialog open={openModal} onClose={() => setOpenModal(false)}>
                <DialogTitle>Eliminar Rol</DialogTitle>
                <DialogContent>
                    ¿Eliminar el Rol <b>{selectedRol.name}</b>?
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="primary" onClick={handleDeleteRole} sx={{ textTransform: 'none', fontWeight: 700 }}>
                        Aceptar
                    </Button>
                    <Button variant="outlined" color="secondary" onClick={() => setOpenModal(false)} sx={{ textTransform: 'none' }}>
                        Cancelar
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default AdminRoles;
